module.exports = __webpack_public_path__ + "static/scale-model-of-anthony-hopkins'-star-in-glendale-california-4eb5e0c7c8a429b9d790ae102c6f1a09.png";